import { IExternalDirectoryRecord } from '../externalDirectory/types';
import { IRestructuredContactsByPhoneNumberActionTypes } from './types';

export type IRestructuredContactsByPhoneNumberActions =
    | {
          type: IRestructuredContactsByPhoneNumberActionTypes.SET_RESTRUCTURED_CONTACTS_BY_PHONE_NUMBER;
          payload: Record<string, IExternalDirectoryRecord>;
      }
    | {
          type: IRestructuredContactsByPhoneNumberActionTypes.SET_RESTRUCTURED_CONTACTS_BY_PHONE_NUMBER_PROCESSING;
          payload: boolean;
      };

export const setRestructuredDirectoryContactsByPhoneNumber = (
    contacts: Record<string, IExternalDirectoryRecord>
): IRestructuredContactsByPhoneNumberActions => ({
    type:
        IRestructuredContactsByPhoneNumberActionTypes.SET_RESTRUCTURED_CONTACTS_BY_PHONE_NUMBER,
    payload: contacts,
});

export const setRestructuredDirectoryContactsByPhoneNumberLoading = (
    isLoading: boolean
): IRestructuredContactsByPhoneNumberActions => ({
    type:
        IRestructuredContactsByPhoneNumberActionTypes.SET_RESTRUCTURED_CONTACTS_BY_PHONE_NUMBER_PROCESSING,
    payload: isLoading,
});
